
<template>
  <component v-bind:is="componentName"></component>
</template>

<script>
 import DemoAccountForm from '@/components/DemoAccountForm';
 import LiveAccountForm from '@/components/LiveAccountForm';
  export default {
    components: { 'demo' : DemoAccountForm, 'live' : LiveAccountForm },
    data(){
      return{
        componentName : 'demo'
      }
    },
    created(){
      this.componentName = this.$route.params.type;
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/views/Register.vue